// extracted by mini-css-extract-plugin
export default {"status-text":"styles_status-text__odNVo"};